import React, { useState, useContext, useRef } from "react";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
	const [open, setOpen] = useState(false);
	const [openDropdown, setOpenDropdown] = useState(true);
	const [openModal, setOpenModal] = useState(false)
	const [data, setData] = useState({
		email: "",
	});
	const [helpDeskData, setHelpDeskData] = useState({
		email: "",
		name: "",
		message: "",
	});
	const urlWaitlist = "https://iexchange-backend.herokuapp.com/contacts/waitlist";
	const urlHelpdesk =
		"https://iexchange-backend.herokuapp.com/contacts/helpdesk";

	const sendWaitlist = (e) => {
		e.preventDefault();
		let empInfo = {
			email: data.email,
		};
		try {
			fetch(urlWaitlist, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(empInfo),
			}).then((response) => response.json());
		} catch (error) {
			console.log("this is a godamn mistake", error);
		}

		setData({
			email: "",
		});
	};

		const changeHandler = (e) => {
			const newData = { ...data };
			newData[e.target.name] = e.target.value;
			setData(newData);
			console.log(newData);
		};


		const sendHelpdesk = (e) => {
			e.preventDefault();
			let empInfo = {
				email: helpDeskData.email,
				name: helpDeskData.name,
				message: helpDeskData.message,
			};
			try {
				fetch(urlHelpdesk, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(empInfo),
				}).then((response) => response.json());
				
			} catch (error) {
				console.log("this is a godamn mistake", error);
			}
			setHelpDeskData({
				email: "",
				name: "",
				message: "",
			});
		};

		const helpDeskSubmit = (e) => {
			e.preventDefault();
		};
		
		const helpDeskChangeHandler = (e) => {
			const newData = { ...helpDeskData };
			newData[e.target.name] = e.target.value;
			setHelpDeskData(newData);
			console.log(newData);
		};

	const openFooterMenu = (e) => {
		setOpenDropdown(e.target.value);
		setOpenDropdown(!openDropdown);
	};

	const openBurger = () => {
		setOpen(!open);
		console.log("you clicked me");
	};



  const scrollToTop = () => {
    window.scroll({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
    console.log("whatsapp");
  }

	const handleModal = () => {
		setOpenModal(!openModal)
		
	}

	const myRef = useRef(null)
	const executeScroll = () => myRef.current.scrollIntoView()  

	return (
		<AppContext.Provider
			value={{
				open,
				setOpen,
				openBurger,
				openFooterMenu,
				openDropdown,
				scrollToTop,
				myRef,
				executeScroll,
				sendWaitlist,
				changeHandler,
				data,
				openModal,
				handleModal,
				sendHelpdesk,
				helpDeskData,
				helpDeskSubmit,
				helpDeskChangeHandler,
			}}>
			{children}
		</AppContext.Provider>
	);
};

export const useGlobalContext = () => {
	return useContext(AppContext);
};

export { AppContext, AppProvider };
